import { CountryCode } from "./CountryCode";
import { LanguageCode } from "./LanguageCode";
import { HomeQuickMenuItems, LeftMenuItems, TopUserMenuItems } from "./MenuItems";
import { CompanyTypes, DeviceModels } from "./RayCodes";
import { InstallationGuideList } from "./RayGuideCodes";
import Sitemap from "./Sitemap";
import { ENV_DEVELOPMENT, ENV_PRODUCTION, ORG_HQ, ORG_BRANCH, ORG_SUBSIDIARY, USER_TYPE_BRANCH, USER_TYPE_DEALER } from "./appConstants";
// BUG-241 — API 헤더 구성 경로를 safeStorage 로 통일 (차단 환경 SecurityError 방지).
import { safeGetItem } from "../lib/safeStorage";

const JWT = () => {
    return {
        headers: {
            token: safeGetItem("userToken"),
            'x-ray-clist': safeGetItem("clist"),
        }
    }
}

const RT_TOKEN = () => {
    return {
        headers: {
            token: safeGetItem("rtToken")
        }
    }
}

// RAYGuard 백엔드(rayguard-api)는 별도 production 인프라가 없어 모든 클라이언트 환경에서
// development 엔드포인트를 사용한다. origin 기반 분기는 의도적으로 미적용.
// 참고:
//  - SmartDent 라이선스(`src/lib/ddb.js`)는 IMP-432(#380) 이후 이 정책과 갈린다 —
//    DDB 업스트림은 호스트 무관 production 고정(`DDB_ENV`)이며 dev 프록시를 경유하지 않는다.
//    (dev/prod DDB 엔드포인트가 동일 서버를 가리켜 데이터 정합 이슈 없음 — 사용자 확정 2026-08-05)
//  - 별도 prod 인프라 도입 시 origin 기반 분기를 다시 활성화할 예정.
// PR #211 review (Blocker #1) — 이전 dead-code(unreachable return) 가 검수 우려를 낳아 단일 return 으로 정리.
const CheckEnv = () => ENV_DEVELOPMENT;

const AppConfig = {
    API_SERVER_PATH: CheckEnv() === ENV_PRODUCTION ? "https://api.raymedical.com/api" : "https://3jwja9uhsf.execute-api.ap-northeast-2.amazonaws.com/production",

    // WebSocket endpoint
    WS_SERVER_PATH: "wss://4n2ol84ifb.execute-api.ap-northeast-2.amazonaws.com/production",

    USER_API_PATH : CheckEnv() === ENV_PRODUCTION ? 'https://api-manager-user.rayteams.com' : 'https://api-manager-user.raydevelop.com',
    GROUP_API_PATH : CheckEnv() === ENV_PRODUCTION ? 'https://api-ap-northeast-2-group.rayteams.com' : 'https://api-ap-northeast-2-group.raydevelop.com',

    S3_ID: "AKIAV6JBTAHFFZXQPCK5",
    S3_KEY: "GAbG5nO8LWNP30woZEOQY+o5iqDISO4wELyPtWv/",
    S3_BUCKET: "ray-data",
    S3_REGION: "ap-northeast-2",
    API_BIQ_PATH: "https://common.rayplatform.com/bq/query",
    API_FIRESTORE_PATH: "https://api-store.rayplatform.com"
}

// org 기반 단일 판별 (IMP-305 — 하드코딩 Branch 배열/companyId fallback 제거).
// org 누락(undefined/null/'')은 prod 데이터상 발생하지 않으나, 발생 시 warn 후 최소권한 DEALER (fail-safe).
const UserType = (companyId, org) => {
    if (org === ORG_HQ) return ORG_HQ;                                        // 'HQ'
    if (org === ORG_BRANCH || org === ORG_SUBSIDIARY) return USER_TYPE_BRANCH; // 'Branch'/'Subsidiary'
    // org 누락(undefined/null/'')인데 companyId 존재 = 예상외 데이터. 무음 권한 강등 방지 위해 관측(§7/BUG-119).
    if (!org && companyId) {
        console.warn('[guard] UserType: companyInfo.org missing — defaulting to DEALER', {
            handler: 'UserType', companyId, org, reason: 'org empty; least-privilege fallback',
        });
    }
    return USER_TYPE_DEALER;
}

const RAYGTTestMode = false;

export {
    AppConfig, CompanyTypes, CountryCode, DeviceModels, HomeQuickMenuItems, InstallationGuideList, JWT, LanguageCode, LeftMenuItems,
    // CheckEnv,
    RAYGTTestMode, RT_TOKEN, Sitemap,
    TopUserMenuItems, UserType
};

